import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getNews } from '../../api/service';
import { capitalizeFirstLetter } from "../../utils/letters";

function toList(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.results)) return data.results;
    return [];
}

export default function NoticiasPage() {
    const navigate = useNavigate();
    const [newsData, setNewsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        getNews()
            .then((data) => { if (!cancelled) setNewsData(toList(data)); })
            .catch(() => { if (!cancelled) setNewsData([]); })
            .finally(() => { if (!cancelled) setIsLoading(false); });
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        document.title = 'Noticias | Somnus';
        return () => { document.title = 'Somnus'; };
    }, []);

    const noticias = Array.isArray(newsData) ? newsData.slice(0,10) : [];

    return (
        <main className="page-noticias font-n">
                <div className="banner-course banner-news-page">
                    <h4>Noticias</h4>
                    <p className="page-noticias-desc">
                        Noticias de los últimos 6 meses. Las publicaciones más antiguas no se muestran.
                    </p>
                </div>
            <section className="page-noticias-content">
                <div className="btn-back-container">
                    <button onClick={() => navigate(-1)}>
                        <i className="ri-arrow-go-back-line d-inline d-md-none"></i><span className="d-none d-md-inline">Volver</span>
                    </button>
                    
                </div>
                {isLoading ? (
                    <div className="loader-container">
                        <img src="/icon/carga-puntos.svg" alt="Cargando noticias" style={{ width: '180px' }} />
                        <p className="txt-loading">Cargando noticias...</p>
                    </div>
                ) : noticias.length > 0 ? (
                    <div className="page-noticias-grid">
                        {noticias.map((news) => (
                            <div className="news-card page-news-card" key={news.id}>
                                <div className="img-wrapper">
                                    <img src={news.imagen_portada || news.imagen_url || "/img/course/1.webp"} alt={news.titulo} />
                                </div>
                                <span className="date-card-n">{news.fecha_formateada || news.fecha || "Reciente"}</span>
                                <div className="card-content-news">
                                    <p className="news-name">{capitalizeFirstLetter(news.titulo)}</p>
                                    <span className="news-txt">{capitalizeFirstLetter(news.bajada || news.resumen)}</span>
                                    <div className="news-info-row">
                                        <Link to={`/noticia/${news.slug || news.id}`}>
                                            <span>Leer más</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="txt-resp">No hay noticias disponibles (solo se muestran noticias de los últimos 6 meses).</p>
                )}
            </section>
        </main>
    );
}
